import React from "react";

function cyrcleExclamationIconRed() {
  return (
    <svg
      width="90"
      height="90"
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="45" cy="45" r="45" fill="#FFEBEE" />
      <circle cx="45.0006" cy="45.0006" r="32.1429" fill="#FFDEDE" />
      <path
        d="M45.3492 29.5352C53.6979 29.5352 60.4655 36.3042 60.4655 44.6514C60.4655 52.9986 53.6979 59.7677 45.3492 59.7677C37.0005 59.7677 30.2329 52.9986 30.2329 44.6514C30.2329 36.3042 37.0005 29.5352 45.3492 29.5352ZM45.3492 32.055C38.4033 32.055 32.7528 37.7055 32.7528 44.6514C32.7528 51.5974 38.4033 57.2478 45.3492 57.2478C52.2951 57.2478 57.9456 51.5974 57.9456 44.6514C57.9456 37.7055 52.2951 32.055 45.3492 32.055ZM45.3477 48.4335C45.7482 48.4335 46.1323 48.5926 46.4155 48.8758C46.6987 49.159 46.8578 49.5431 46.8578 49.9436C46.8578 50.3442 46.6987 50.7283 46.4155 51.0115C46.1323 51.2947 45.7482 51.4538 45.3477 51.4538C44.9472 51.4538 44.5631 51.2947 44.2799 51.0115C43.9967 50.7283 43.8376 50.3442 43.8376 49.9436C43.8376 49.5431 43.9967 49.159 44.2799 48.8758C44.5631 48.5926 44.9472 48.4335 45.3477 48.4335ZM45.3401 37.0933C45.6143 37.0929 45.8794 37.192 46.0862 37.3721C46.293 37.5522 46.4275 37.8012 46.4648 38.0728L46.4754 38.2255L46.4814 45.0309C46.4817 45.3182 46.3728 45.595 46.1769 45.8052C45.9809 46.0154 45.7124 46.1433 45.4257 46.1631C45.139 46.1828 44.8555 46.093 44.6325 45.9117C44.4095 45.7304 44.2637 45.4712 44.2245 45.1866L44.214 45.0324L44.2079 38.2285C44.2077 38.0795 44.2369 37.9319 44.2938 37.7942C44.3507 37.6565 44.4341 37.5313 44.5394 37.4259C44.6447 37.3205 44.7698 37.2368 44.9074 37.1797C45.0451 37.1227 45.1911 37.0933 45.3401 37.0933Z"
        fill="#F44336"
      />
    </svg>
  );
}

export default cyrcleExclamationIconRed;
